// import { Axios } from "../../../../../legacyComponents/util"

import axios from "axios";
import { getBaseURL } from "../../../../../api/axios";
// import api from "../../../../../api/axios"

export default async function addInsuranceProof(
  insuranceProof,
  healthInsuranceId,
) {
  try {
    const baseURL = getBaseURL();
    const url = `${baseURL}user/healthInsurance/${healthInsuranceId}/document`;
    const token = localStorage.getItem("token");

    // build form data
    const formData = new FormData();
    formData.append("file", insuranceProof);

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data;
  } catch (error) {
    console.error(error);
    return {};
  }
}
